import { gql } from '@apollo/client'

export const REGISTER_USER_EVENT = gql`
  mutation RegisterUserEvent($event: String!, $attributes: [String!]!) {
    RegisterUserEvent(event: $event, attributes: $attributes)
  }
`
